export default __webpack_public_path__ + "static/media/bz7.388d0250.png";